module.exports = __webpack_public_path__ + "img/JustaBadLand.e14d7f28.png";